import Nullstack from 'nullstack';
export default function IconGitCherryPick({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-git-cherry-pick",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "7",
    cy: "12",
    r: "3"
  }), "   ", Nullstack.element("path", {
    d: "M7 3v6"
  }), "   ", Nullstack.element("path", {
    d: "M7 15v6"
  }), "   ", Nullstack.element("path", {
    d: "M13 7h2.5l1.5 5l-1.5 5h-2.5"
  }), "   ", Nullstack.element("path", {
    d: "M17 12h3"
  }), " ");
}